export const voucherStrings = {
  english: {
    question: 'Do you have a voucher?',
    validate: 'Validate',
    text: 'If you don’t have a Media Integration voucher, you can get one ',
    here: 'here',
  },
  japan: {
    question: 'バウチャーをお持ちですか？',
    validate: '認証する',
    text: 'メディアインテグレーションのバウチャーをお持ちでない場合は',
    here: 'こちら',
    text2: 'からお求めいただけます。',
  },
};
